// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"825386d9","732":"fda73a07","977":"51ec43bb"}[chunkId] + ".chunk.js";
};